<template>
    <div class="workorderInfromation" style="background-color: #FCF6EC">
        <div class="workorderInfromation_title">
            <!--<div class="workorderInfromation_t_zhzx" :class="{'QZX':timeLineData.roleGrade=='1','ZLD':timeLineData.roleGrade=='2','ZGLD':timeLineData.roleGrade=='4','ZX':timeLineData.roleGrade=='3'}">-->
                <!--{{timeLineData.czCzdwmc}}-->
            <!--</div>-->
            <div class="workorderInfromation_t_zhzx ZX" v-if="timeLineData.czCzjskey=='WGSJ_ZX'">
                指挥中心
            </div>
            <div class="workorderInfromation_t_zhzx ZLD" v-if="timeLineData.czCzjskey=='WGSJ_FGLD'">
                分管领导
            </div>
            <div class="workorderInfromation_t_zhzx ZLD" v-if="timeLineData.czCzjskey=='WGSJ_ZGLD'">
                主管领导
            </div>
            <div class="workorderInfromation_t_describe">
                {{timeLineData.czCzrmc}}
            </div>
            <div class="workorderInfromation_t_cb">
                催办
            </div>
            <div class="workorderInfromation_t_zhzx QZX" v-if="timeLineData.czFpdxjs=='WGSJ_WGY'">
                网格员
            </div>
            <div class="workorderInfromation_t_describe" v-if="timeLineData.czFpdxjs=='WGSJ_WGY'">
                {{timeLineData.czFpdxmc}}
            </div>
            <div class="workorderInfromation_t_zhzx ZGLD" v-if="timeLineData.czFpdxjs=='WGSJ_CBDW'">
                {{timeLineData.czFpdxmc}}
            </div>
            <div class="workorderInfromation_t_mainResponse" v-if="timeLineData.czFpsfzz=='1'">
                主责
            </div>
        </div>
        <div class="workorderInfromation_progressTime">
            <span class="icon-time_fill workorderInfromation_icon"></span>
            <div class="workorderInfromation_p_time">
                {{timeLineData.czCzsj}}
            </div>
            <div class="workorderInfromation_p_day">
                第{{timeLineData.theDay}}天
            </div>
        </div>
        <div class="workorderInfromation_option">
            <span class="icon-progress workorderInfromation_icon"></span>
            <div>
                <span v-if="timeLineData.czCzjgzt=='1'" class="workorderInfromation_option_label">处置结果：</span><span v-if="timeLineData.czCzjgzt=='0'" class="workorderInfromation_option_label">驳回原因：</span>{{timeLineData.czCzjgwb}}
            </div>
        </div>
        <div class="workorderInfromation_line" v-if="timeLineData.files && timeLineData.files.length>0"></div>
        <TimeLine_file :files="timeLineData.files" v-if="timeLineData.files && timeLineData.files.length>0"></TimeLine_file>
    </div>
</template>

<script>
    import {reactive, ref, getCurrentInstance, onMounted, inject} from 'vue'
    import TimeLine_file from "./TimeLine_file.vue"
    export default {
        name: "cbdbInformation",
        props:["timeLineList"],
        components: {
            TimeLine_file
        },
        setup(props, context) {
            // let timeLineData = reactive({
            //     "czCzdwmc": "指挥中心",//处置单位名称
            //     "czCzrmc": "张倩",  //处置人名称
            //     "czCzsj": "2021.12.02 14:11:38", //处置时间
            //     "theDay": "1", //第n天"
            // })
            let timeLineData = props.timeLineList;
            return {
                timeLineData
            }
        }
    }
</script>

<style scoped>

</style>
